import { Task } from '../domain/task';
import { WorkflowType } from '../domain/enums/workflow-type';
import { Router } from '@angular/router';
import { AuditReportRecord } from '../domain/audit-report-record';
import { FollowUp } from '../domain/follow-up';
import { Mention } from '../domain/mention';
import { Property } from '../domain/property';

export class TaskUtils {
   static v1TaskRoute = '/tasks/';
   static v2TaskRoute = '/task/v2/instance/';

   static async goToTask(taskData: Task, router: Router, currentProp: Property) {
      const fromUrl = router.url; // Capture the current location as `from`

      const taskId = taskData.processId;
      const state = { state: { task: taskData } };

      if (currentProp.isPhobosEnabled || taskData?.type === WorkflowType.Form) {
         await router.navigate([TaskUtils.v2TaskRoute + taskId], {
            ...state,
            queryParams: { from: fromUrl }
         });
      } else {
         await router.navigate([TaskUtils.v1TaskRoute + taskId], {
            ...state,
            queryParams: { from: fromUrl }
         });
      }
   }

   static async goToForm(formData: FollowUp, router: Router, currentProp: Property) {
      if (currentProp.isPhobosEnabled || formData?.type == WorkflowType.Form) {
         await router.navigateByUrl(TaskUtils.v2TaskRoute + formData.processId);
      } else {
         await router.navigateByUrl(TaskUtils.v1TaskRoute + formData.processId);
      }
   }

   static async goToMention(
      mentionData: Mention,
      router: Router,
      currentProp: Property
   ) {
      if (currentProp.isPhobosEnabled || mentionData?.type == WorkflowType.Form) {
         await router.navigateByUrl(TaskUtils.v2TaskRoute + mentionData.processId);
      } else {
         await router.navigateByUrl(TaskUtils.v1TaskRoute + mentionData.processId);
      }
   }

   static async goToTaskViaAuditRecord(
      report: AuditReportRecord,
      router: Router,
      currentProp: Property
   ) {
      const fromUrl = router.url;
      const taskId = report.processId;

      if (currentProp.isPhobosEnabled || report.dailyState === 'FORM') {
         await router.navigate([TaskUtils.v2TaskRoute + taskId], {
            queryParams: { from: fromUrl }
         });
      } else {
         await router.navigate([TaskUtils.v1TaskRoute + taskId], {
            queryParams: { from: fromUrl }
         });
      }
   }
}
